import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@postcheesy/ui-lib/molecules";
import React, { useEffect, useState } from "react";

import { Layout } from "../../components/layouts/layout";
import { FormLogin } from "../../components/sections/forms/login";
import { Navigate } from "react-router-dom";
import { ROUTES } from "../../resources/constants/routes";
import { useUser } from "../../resources/contexts/UserContext";


export const LoginPage2: React.FC = () => {
  const { user, loading } = useUser();

  if (loading) {
    return <div className="flex h-screen items-center justify-center">Loading...</div>;
  }

  if (user) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }
  return (
    <>
      <Layout>
        <div className="container relative mx-auto grid max-h-full w-full items-center justify-center lg:grid-cols-2 lg:px-0">
          <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[450px] lg:mx-0 lg:pl-8">
            <Card className="w-full">
              <CardHeader>
                <CardTitle className="text-2xl">{"Authentification"}</CardTitle>
                <CardDescription className="w-fit text-pretty">
                  Entrez vos informations ci-dessous pour vous connecter à votre
                  compte.
                </CardDescription>
              </CardHeader>
              <CardContent>
                <FormLogin />
              </CardContent>
            </Card>
          </div>
          <div className="relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex">
            <div className="z-2 absolute inset-0 w-[50vw] bg-[#870037] bg-cover"></div>
            <div className="absolute inset-0 z-0 w-[50vw] bg-[url('https://yannickacademie.ca/img/img_banner_test.jpeg')] bg-cover opacity-100 mix-blend-multiply"></div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export const LoginPage: React.FC = () => {
  const { user, loading } = useUser();

  if (loading) {
    return <div className="flex h-screen items-center justify-center">Loading...</div>;
  }

  if (user) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }
  return (
    <>
      <Layout>
        <div className="container relative mx-auto grid max-h-full w-full items-center justify-center lg:grid-cols-2 lg:px-0">
          
          <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[450px] lg:mx-0 lg:pl-8">
            <Card className="w-full">
              <CardHeader>
                <CardTitle className="text-2xl">{"Authentification"}</CardTitle>
                <CardDescription className="w-fit text-pretty">
                  Entrez vos informations ci-dessous pour vous connecter à votre
                  compte.
                </CardDescription>
              </CardHeader>
              <CardContent>
                <FormLogin />
              </CardContent>
            </Card>
          </div>
          <div className="relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex">
            <div className="z-2 absolute inset-0 w-[50vw] bg-[#870037] bg-cover"></div>
            <div className="absolute inset-0 z-0 w-[50vw] bg-[url('https://yannickacademie.ca/img/img_banner_test.jpeg')] bg-cover opacity-100 mix-blend-multiply"></div>
          </div>
        </div>
      </Layout>
    </>
  );
};
